import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function AddToJourneySheet({ open, onClose }) {
  const { t } = useLang();
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!content.trim()) {
      toast.error("Write something first");
      return;
    }
    setSaving(true);
    try {
      await api.post("/annals", { content, title, type: "reflection" });
      toast.success(t("journal.saved"));
      setContent(""); setTitle("");
      onClose();
    } catch (e) {
      toast.error("Could not save. Try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="bottom" className="rounded-t-2xl border-t" style={{ backgroundColor: "var(--vedari-surface)", borderColor: "var(--vedari-divider)" }}>
        <SheetHeader className="text-left">
          <SheetTitle className="font-serif text-h2" style={{ color: "var(--vedari-ink)" }}>
            {t("journal.add")}
          </SheetTitle>
        </SheetHeader>
        <div className="mt-6 space-y-4">
          <input
            data-testid="journal-title-input"
            className="vedari-input"
            placeholder={t("journal.short_title")}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <textarea
            data-testid="journal-content-input"
            className="vedari-input min-h-[160px] resize-none"
            placeholder={t("journal.write_prompt")}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
          <div className="flex gap-3 pt-2">
            <button data-testid="journal-cancel-btn" onClick={onClose} className="vedari-btn-secondary flex-1">
              {t("journal.cancel")}
            </button>
            <button data-testid="journal-save-btn" onClick={submit} disabled={saving} className="vedari-btn-primary flex-1">
              {saving ? "…" : t("journal.save")}
            </button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
